import { useState } from 'react'

/** Vignette qui affiche une icône à la place d'une image introuvable. */
export function Thumb({ src, alt }: { src: string; alt: string }) {
  const [broken, setBroken] = useState(false)
  if (broken) return <span className="g-thumb__missing mdi mdi-image-off-outline" aria-label={alt} />
  return <img src={src} alt={alt} loading="lazy" onError={() => setBroken(true)} />
}
